import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from '../../../../Containers/Config/index.js';
import { GET_CARD_LIST, GET_CARD_LIST_SUCCESS, GET_CARD_LIST_ERROR } from '../../actionType.js';
import apiCall from '../../apiCall';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getCardDetails({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/user-cards`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        ...payload.urlParam,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_CARD_LIST_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: GET_CARD_LIST_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_CARD_LIST_ERROR, payload: error });
  }
}

export function* watchCardDetails() {
  yield takeEvery(GET_CARD_LIST, getCardDetails);
}

function* cardDetailsSaga() {
  yield all([fork(watchCardDetails)]);
}

export default cardDetailsSaga;
